/* BBQ Kitchen Pros — global USP normalizer. Edit TAX_STATES here once to update every product page. */
(function () {
  var TAX_STATES = 'NY, NJ, FL, OH, NC, CA & MA';
  var LINE = 'Except ' + TAX_STATES;
  var PAREN = '(except ' + TAX_STATES + ')';
  var RE_NAME = /no\s+sales\s+tax/i;
  var RE_PAREN = /\((?:outside|except|excl\.?)[^)]*\)/i;
  function fixNode(n) {
    if (n.dataset.uspTaxFixed) return;
    var small = n.querySelector('small');
    if (small) { small.textContent = PAREN; n.dataset.uspTaxFixed = '1'; return; }
    var d = n.nextElementSibling;
    if (d && /desc/i.test(d.className)) { d.textContent = LINE; n.dataset.uspTaxFixed = '1'; return; }
    if (RE_PAREN.test(n.innerHTML)) { n.innerHTML = n.innerHTML.replace(RE_PAREN, PAREN); n.dataset.uspTaxFixed = '1'; return; }
    var p = n.parentElement;
    if (p) { var pd = p.querySelector('[class*="desc"]'); if (pd && pd !== n) { pd.textContent = LINE; n.dataset.uspTaxFixed = '1'; } }
  }
  function run() {
    if (!document.body || !/template-product/.test(document.body.className)) return;
    var sel = '.usp-name, .af-trust-name, .ar-trust-name, .dh-trust-name, .te-trust-name, [class*="usp"] *, [class*="trust"] *';
    var seen = [];
    document.querySelectorAll(sel).forEach(function (n) {
      if (n.children.length > 2) return;
      if (!RE_NAME.test(n.textContent)) return;
      if (n.textContent.trim().length > 80) return;
      if (seen.some(function (s) { return s.contains(n) || n.contains(s); })) return;
      seen.push(n);
    });
    seen.forEach(fixNode);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setTimeout(run, 800);
  document.addEventListener('shopify:section:load', run);
})();

/* Blaze pages: drop the "Call for eligibility" tail from the checkout-code banner. */
(function () {
  function trimBlazeBanner() {
    if (!window.bkpIsBlaze) return;
    document.querySelectorAll('.rp-promo-detail').forEach(function (d) {
      if (d.dataset.blazeTrimmed) return;
      var a = d.querySelector('a[href^="tel:"]');
      if (!a) return;
      var prev = a.previousSibling;
      while (prev && prev.nodeType === 3 && /^[\s\u00a0·]*$/.test(prev.textContent)) { var p2 = prev.previousSibling; prev.remove(); prev = p2; }
      a.remove();
      d.innerHTML = d.innerHTML.replace(/(\s|&nbsp;)*·(\s|&nbsp;)*$/, '');
      d.dataset.blazeTrimmed = '1';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', trimBlazeBanner); else trimBlazeBanner();
  setTimeout(trimBlazeBanner, 800);
  document.addEventListener('shopify:section:load', trimBlazeBanner);
})();
